(function( $ ) {
	const ROOM_PRICES = {
		1: 2600, // Twin
		2: 2600, // Queen m/ ekstraseng
	};

	const ROOM_MAX_GUESTS = {
		1: 2, // Twin
		2: 3, // Queen m/ ekstraseng
	};

	const NIGHTS = {
		1: 2,
		2: 3,
	};

	// const TICKET_ADULT = 1595;
	// const TICKET_CHILDREN = 1350;
	const TICKET_ADULT = false; // Disabled
	const TICKET_CHILDREN = false; // Disabled
	const BREAKFAST = 125;

	function updateRoomOptions() {
		const guests = parseInt( $( '[name="your-guests"]' ).val(), 10 ) || null;
		if ( !guests ) return;

		const $roomSelect = $( '[name="your-room"]' );
		const currentIndex = $roomSelect[ 0 ].selectedIndex;

		$roomSelect.find( 'option' ).each( function( i ) {
			if ( i === 0 ) return; // skip blank
			const tooSmall = guests > ROOM_MAX_GUESTS[ i ];
			$( this ).prop( 'disabled', tooSmall );
			if ( tooSmall && currentIndex === i ) {
				$roomSelect[ 0 ].selectedIndex = 0;
			}
		} );
	}

	function updateHotelPrice() {
		const $stay = $( '[name="your-stay"]' );
		const $room = $( '[name="your-room"]' );

		const stayIndex = $stay[ 0 ]?.selectedIndex;
		const roomIndex = $room[ 0 ]?.selectedIndex;

		const nights = NIGHTS[ stayIndex ] ?? null;
		const roomPrice = ROOM_PRICES[ roomIndex ] ?? null;

		const guests = parseInt( $( '[name="your-guests"]' ).val(), 10 ) || 0;
		const adults = parseInt( $( '[name="your-tickets-adult"]' ).val(), 10 ) || 0;
		const children = parseInt( $( '[name="your-tickets-children"]' ).val(), 10 ) || 0;

		const fmt = ( n ) => n.toLocaleString( 'nb-NO' ) + ',-';

		const breakfastTotal = nights && roomPrice ? guests * BREAKFAST * nights : 0;
		const roomTotal = nights && roomPrice ? roomPrice * nights + breakfastTotal : null;

		const adultTotal = adults * TICKET_ADULT;
		const childTotal = children * TICKET_CHILDREN;
		const ticketsTotal = adultTotal + childTotal;

		$( '#ps-room-price' ).text( roomTotal !== null ? fmt( roomTotal ) : '–' );

		if ( adults > 0 ) {
			$( '#ps-adult-count' ).text( adults + ' ×' );
			$( '#ps-adult-price' ).text( fmt( adultTotal ) );
			$( '#ps-adult-line' ).show();
		} else {
			$( '#ps-adult-line' ).hide();
		}

		if ( children > 0 ) {
			$( '#ps-children-count' ).text( children + ' ×' );
			$( '#ps-children-price' ).text( fmt( childTotal ) );
			$( '#ps-children-line' ).show();
		} else {
			$( '#ps-children-line' ).hide();
		}

		if ( roomTotal !== null || ticketsTotal > 0 ) {
			$( '#ps-total-price' ).text( fmt( (roomTotal ?? 0) + ticketsTotal ) );
		} else {
			$( '#ps-total-price' ).text( '–' );
		}
	}

	function handleChange() {
		updateRoomOptions();
		updateHotelPrice();
	}

	$( document ).on(
		'change input',
		'[name="your-stay"], [name="your-room"], [name="your-guests"], [name="your-tickets-adult"], [name="your-tickets-children"]',
		handleChange,
	);

})( jQuery );
